import React, { useEffect } from 'react';
import PresaleForm from '../components/presale'

function Presale() {

  useEffect(() => {
    localStorage.setItem("theme", "is_dark");
  }, [])

  return (
    <div>
      <PresaleForm />
    </div>
  );
}

export default Presale;
